import { useMemo } from 'react';
import { FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';

type TProps = {
  bannerMessage?: string;
  bannerStatus: 'info' | 'error';
};

export const Banner: React.FC<TProps> = ({ bannerStatus, bannerMessage }) => {
  const showBanner = useMemo(() => !!bannerMessage, [bannerMessage]);

  return (
    <>
      {showBanner && (
        <div
          className={`flex text-white ${bannerStatus === 'info' ? 'bg-green-600' : 'bg-red-600'} items-center`}>
          <div className='flex items-center m-1'>
            {bannerStatus === 'info' ? (
              <FaInfoCircle />
            ) : (
              <FaExclamationCircle />
            )}
            <div className='text-sm px-2 tracking-[.1px] font-normal'>
              {bannerMessage}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
